import React, { useState } from "react";

import firebase from "firebase/compat/app";
import AppContext, { Role } from "../AppContext";
import { Alert } from "../themes-views/system-design/DSAlert";

type Props = {
  children: React.ReactNode;
  user: firebase.User & Role;
};

const AppContextProvider: React.FC<Props> = ({ children, user }) => {
  const [alert, setAlert] = useState<Alert | undefined>(undefined);

  const showAlert = (newAlert: Alert | undefined) => {
    setAlert(newAlert);
  };
  return (
    <AppContext.Provider value={{ user, alert, showAlert }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
